import React from 'react';

export const grossIncomeAdditionalInfo = () => (
  <va-additional-info trigger="What’s gross income?">
    <p>
      Gross income is money earned from employment before taxes. It includes
      military pay. It doesn’t include Social Security benefits, VA benefits,
      stock dividends, or investment income.
    </p>
  </va-additional-info>
);
